import { type InferRouteNames } from "@/types/infer-route-names"

export const OnboardingRouteNames = {
    // MoveOut first steps
    MoveOut: "moveOut",
    MoveOutIneligible: "moveOutIneligible",
    MoveOutMeterDetails: "moveOutMeterDetails",
    // Default onboarding steps (direct/navigator)
    MeterDetails: "meterDetails",
    MeterDetailsWithDetails: "meterDetailsWithDetails",
    MeterDetailsWithAffiliate: "meterDetailsWithAffiliate",
    MeterDetailsWithPartner: "meterDetailsWithPartner",
    MeterDetailsMonoEnergy: "meterDetailsMonoEnergy",
    ProviderCalendar: "providerCalendar",
    EnergyLandscape: "energyLandscape",
    MeterReadings: "meterReadings",
    ElectricityMeterIneligible: "electricityMeterIneligible",
    GasMeterIneligible: "gasMeterIneligible",
    AddressIneligible: "addressIneligible",
    Quote: "quote",
    PersonalDetails: "personalDetails",
    // Navigator last steps
    Confirmation: "confirmation",
    // Direct last steps & checkout pages
    PaymentDetails: "paymentDetails",
    PaymentDetailsSuccess: "paymentDetailsSuccess",
    PrePayment: "prePayment",
    PrePaymentCdf: "prePaymentCdf",
    PaymentDetailsConsent: "paymentDetailsConsent",
    PaymentDetailsFinancialSituation: "paymentDetailsFinancialSituation",
    PaymentDetailsFinancialSituationSuccess: "paymentDetailsFinancialSituationSuccess",
    PaymentDetailsRetry: "paymentDetailsRetry",
    PaymentDetailsErrorIban: "paymentDetailsErrorIban",
    PaymentDetailsUnpaidBills: "paymentDetailsUnpaidBills",
    PaymentDetailsErrorConsent: "paymentDetailsErrorConsent",
    PaymentDetailsErrorSignature: "paymentDetailsErrorSignature",
    PaymentDetailsErrorPrepayment: "paymentDetailsErrorPrepayment",
    PaymentDetailsPendingPrepayment: "paymentDetailsPendingPrepayment",
    OrderReview: "orderReview",
    Onboarded: "onboarded",
    SecurityDeposit: "securityDeposit",
} as const

export type OnboardingRouteNames = InferRouteNames<typeof OnboardingRouteNames>
